import AclName from '../../../../acl/AclName';
import crmImpersonate from '../../../../procedures/crm/crm-impersonate';
import action from '../../../abstract/action';

export default action({
  main: () => true,
  label: 'Przełącz konto',
  acl: AclName.PartnerCrmImpersonateAccount,
  render: ({ item }) => item?.serviceparent === item?.crm?.serviceparent && item?.crm?._activated_to && Date.parse(item.crm._activated_to) >= Date.now(),
  handle: ({ $vs, $store, $router, item }) => crmImpersonate({ $vs, $store, $router, crm: item.crm }),
});
